import React from "react"

/* Import Local Styles */
import "../icon.css"

const CheckboxSvg = () => (
  <svg
    className="icon no-fill"
    width="30"
    height="30"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.95874 23.239C11.5448 20.9598 18.6653 2.42321 18.8323 1.81766C19.6003 -0.999832 22.6722 0.303785 22.6722 0.303785C22.6722 0.303785 24.6089 1.99428 24.6089 3.02035C24.1581 3.32313 23.7073 3.66796 23.2482 4.04643C22.7974 4.4249 22.3216 4.78654 21.8374 5.13137C19.9175 6.72935 11.094 22.7092 9.95874 24.6099V23.239ZM9.95874 24.6015C8.79007 22.7008 4.69138 18.5965 2.77142 17.0069C2.32065 16.6621 1.85318 16.3004 1.38571 15.922C0.909893 15.5435 0 14.8959 0 14.8959C0 14.8959 2.01178 12.2971 3.00515 12.2971C3.99852 12.2971 5.40093 12.6503 5.88509 13.34C6.85342 15.4342 8.33095 20.9598 9.95874 23.2306V24.6015Z"
      className="fill-with-text-color"
    />
    <path />
  </svg>
)

export default CheckboxSvg
